/* Copyright (c) 2023 Xperi. All Rights Reserved. */

export const SHOW_VIDEO_DEBUG_OVERLAY = 'SHOW_VIDEO_DEBUG_OVERLAY';
export const HIDE_VIDEO_DEBUG_OVERLAY = 'HIDE_VIDEO_DEBUG_OVERLAY';
